module.exports = {"download":{"ja":"ダウンロード","en":"Download"},"save":{"ja":"※保存する際は画像を長押ししてください","en":"※To download, please press down on the image."}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/constants/ranking/certificate/certificate.json
// module id = cp3F
// module chunks = 1